import { SnowUnit } from 'components/blocks/Unit';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { IMostReportedSnowfallItem } from 'api/home/types';
import { IResortPathInfo } from 'api/resort/types';
import React from 'react';
import Link from 'next/link';
import { Routes } from 'routes';
import styles from './style.module.scss';

const SnowfallItem = ({ resort }: { resort: IMostReportedSnowfallItem }) => {
  const href = Routes.resortSnowReport(resort as unknown as IResortPathInfo);

  return (
    <div className={styles.snowfallItem}>
      <h3>
        <Link className={styles.itemTitle} href={href}>{resort.title}</Link>
      </h3>
      <span className={styles.snowfallValue}>
        <SnowUnit values={resort.snow?.last24 ?? undefined} />
      </span>
    </div>
  );
};

type MostReportedSnowfallProps = {
  items?: Array<IMostReportedSnowfallItem> | null;
};

const MostReportedSnowfall = ({ items }: MostReportedSnowfallProps) => {
  const { t } = useOTSTranslation('common');

  if (!items || items.length === 0) {
    return null;
  }

  const itemsToShow = items.filter(({ snow }) => (snow?.last24 ?? 0) > 0).slice(0, 7); // limit to 7 items

  if (itemsToShow.length === 0) {
    return null;
  }

  return (
    <section className={styles.mostReportedSnowfall}>
      <div className={`${styles.container}`}>
        <h2 className={styles.title}>{t('common.mostReportedSnow')}</h2>
        <div className={styles.snowfallList}>
          {itemsToShow.map((resort, index) => (
            <React.Fragment key={resort.uuid}>
              <SnowfallItem resort={resort} />
              {index < itemsToShow.length - 1 && <div className={styles.divider} />}
            </React.Fragment>
          ))}
          <div className={styles.divider} />
          <div className={styles.btn}>
            <Link href={Routes.snowReports()}>{t('common.loadMore')}</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MostReportedSnowfall;
